export type CarrierPortalDocumentType = "pod" | "bol" | "lumper_receipt";

export interface CarrierPortalDocumentUploadInput {
  loadReference: string;
  documentType: CarrierPortalDocumentType;
  fileName: string;
  rawText?: string;
}

export function buildCarrierDocumentUploadDraft(input: CarrierPortalDocumentUploadInput) {
  const ocrRequired = input.documentType === "pod" || input.documentType === "lumper_receipt";
  const extracted = extractDocumentFields(input.rawText ?? "");
  return {
    documentType: input.documentType,
    fileName: input.fileName,
    source: "carrier_portal",
    ocrRequired,
    // Honest state: no OCR has run at draft time. Real vision OCR (or an
    // explicit ocr_unavailable outcome) is applied later by the processing
    // path — a draft must never claim completed extraction.
    ocrStatus: ocrRequired ? "pending" : "not_required",
    draftOnly: input.documentType === "lumper_receipt",
    loadReference: input.loadReference,
    extracted,
  };
}

export function documentUploadAuditSummary(input: CarrierPortalDocumentUploadInput) {
  return `${input.documentType.replaceAll("_", " ")} uploaded for ${input.loadReference}`;
}

function extractDocumentFields(rawText: string) {
  const signedMatch = rawText.match(/signed\s*by[:\s]+([A-Z][A-Za-z .'-]+)/i);
  const amountMatch = rawText.match(/\$([0-9,]+(?:\.[0-9]{2})?)/);
  return {
    signedBy: signedMatch?.[1]?.trim(),
    amountCents: amountMatch ? Math.round(Number(amountMatch[1].replaceAll(",", "")) * 100) : undefined,
    textLength: rawText.length,
  };
}
